import React, { useContext } from 'react';

import EnrollmentFormInvitationModal from 'components/module/EnrollmentFormInvitationModal';
import {
  EnrollmentFormInvitationFormProps,
  EnrollmentFormInvitationModalProps,
} from 'components/module/EnrollmentFormInvitationModal/EnrollmentFormInvitationModal.view';
import { observer } from 'mobx-react-lite';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { EnrollmentFormServiceInstance } from 'services/enrollmentFormService';
import { SurveyServiceInstance } from 'services/surveyService';
import { AuthStoreContext } from 'store/AuthStore';
import { AllErrors } from 'types/Errors';
import { CreateEnrollmentFormForCeoPayload } from 'types/services/EnrollmentForm';

const EnrollmentFormInvitation = (): JSX.Element => {
  // MARK:- Hooks
  const navigate = useNavigate();

  // MARK:- Store
  const AuthStore = useContext(AuthStoreContext);

  // MARK:- Query
  const surveyListQuery = useQuery('survey', SurveyServiceInstance.getList, {
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (err: AllErrors) => {
      console.error(err);
    },
  });

  // MARK:- Mutation
  const sendEnrollmentFormMutation = useMutation(
    (data: CreateEnrollmentFormForCeoPayload) =>
      EnrollmentFormServiceInstance.createForCeo(data),
    {
      onSuccess: (data) => {
        console.log(data);
        navigate('/dashboard/enrollment-forms');
      },
      onError: (error: AllErrors) => {
        console.error(error);
      },
    }
  );

  function onSubmit(values: EnrollmentFormInvitationFormProps) {
    sendEnrollmentFormMutation.mutate({ ...values });
  }

  const generatedProps: EnrollmentFormInvitationModalProps = {
    loading: false,
    onSubmit,
    surveys: surveyListQuery.data?.body || [],
  };
  return <EnrollmentFormInvitationModal {...generatedProps} />;
};

export default observer(EnrollmentFormInvitation);
